import Login from './login/fr_FR'
import Entity from './entity/fr_FR'
import Home from './home/fr_FR'
import Adherent from './adherent/fr_FR'
import Correspondant from './correspondant/fr_FR'
import Document from './document/fr_FR'
import Fiche from './fiche/fr_FR'
import Mutation from './mutation/fr_FR'
import Assistance from './assistance/fr_FR'
import Utilisateur from './user/fr_FR'
import Question from './questionsecrete/fr_FR'
import Password from './password/fr_FR'
import Registration from './registration/fr_FR'
import Forgot from './forgot/fr_FR'
import Gestionnaire from './gestionnaire/fr_FR'
import Download from './download/fr_FR'

const basic = {
  lead: 'Bienvenue dans votre application',
  upload: {
    success: 'Fichier envoyé avec succès',
    error: 'Erreur de traitement du fichier',
  },
  locale: {
    fr_FR: 'FR',
    en_EN: 'EN',
  },
  from: 'Date début',
  to: 'Date fin',
  search: 'Rechercher',
  list: {
    title: 'LST - {0}',
  },
  menu: {
    title: 'Menu',
    home: 'Accueil',
    default: 'Extra<b>ciem</b>',
    links: 'Liens essentiels',

    dashboard: 'Console',

    administratif: 'Administratif',
    adherents: {
      etablissement: 'Adhérents',
      bilans: 'Bilans',
      historiqueBilans: 'Historique bilans',
    },
    documents: {
      titre: 'Mon dossier médical',
      resultatsAnalyses: "Résultats d'examens médico-techniques ",
      consultations: 'Compte-rendu de consultations',
      consultationGynecologique: 'Gynécologie',
      courrier: 'Courriers',
    },
    mutation: 'Mutation participant',
    assistance: 'Assistance',
    participantCoordonnes: 'Mes coordonnées',
    fichesConseil: 'Mes fiches conseil',
    morrespondants: 'Correspondants Établissements',
    particupantsRendezVous: 'Mes Rendez-vous',
    politiqueProtectionDonnees: 'Politique de protection des données',
  },
  auth: {
    error: "Erreur de communication avec le serveur d'autorisation",
    unauthorized: 'Utilisateur ou mot de passe invalide',
    connected: 'Vous êtes maintenant connecté',
    disconnected: 'Vous êtes maintenant déconnecté',
    notLogged: 'Veuillez vous connecter pour accéder à cette fonction',
    accessDenied:
      "Vos habilitations ne permettent pas d'accéder à cette fonction",
    confirmation: {
      expired: 'Le code que vous venez de saisir est expiré',
      notfount: 'Les informations que vous avez saisi sont erronées',
    },
    tokenException:
      "La connexion n'est plus active, veuillez vous reconnecter.",
    reactivate: "L'activation DMC est passée avec succès",
  },
  errors: {
    required: 'Élément obligatoire',
    minLength: 'Longueur minimale de {0} charactères',
    maxLength: 'Longueur maximale de {0} charactères',

    provenanceValidator: "La provenance du participant n'est pas correcte",
    email: 'Champ de type email',
    missmatch: 'Les mots de passes doivent être identiques',
    passwordRegles: 'Le mot de passe ne respecte pas toute les règles',
    emailNotValid: "L'adresse mail saisie n'est pas correcte",
    portableNonValide: "Le portable saisi n'est pas valide",
  },
  form: {
    error: 'Veuillez corriger votre saisie',
    saved: "L'entité a été sauvegardée",
    deleted: "L'entité a été supprimée",
    deletedList: 'Entité(s) supprimée(s)',
    reloaded: "L'entité a été rechargée",
    updatedBy: "L'entité a été modifiée par l'utilisateur #%{principal}",
    deleteAll:
      '|Voulez vous supprimer cette entité ?|Voulez vous supprimer ces #%{count} entités ?',
    deactivateAll:
      '|Voulez vous désactiver cette entité ?|Voulez vous désactiver ces #%{count} entités ?',
    auditHistory: 'Audit modifications',
  },
  button: {
    submit: 'Soumettre',
    confirm: 'Valider',
    confirmation: 'Confirmer',
    create: 'Créer',
    save: 'Sauvegarder',
    send: 'Envoyer',
    cancel: 'Annuler',
    accueil: 'Revenir à la page de connexion',
    new: 'Nouveau',
    delete: 'Supprimer',
    deactivate: 'Désactiver',
    reload: 'Recharger',
    showHistory: "Voir l'historique",
    ok: 'Ok',
    non: 'Non',
    oui: 'Oui',
    resilier: 'Resilier',
    adherer: 'Adherer',
    close: 'Fermer',
    valider: 'Valider',
    edition: 'Edition',
    display: 'Afficher',
    accept: 'Accepter',
    modify: 'Modifier',
    next: 'Suivant',
    previous: 'Précédent',
  },
  stomp: {
    connected: 'Connecté au serveur MOM',
    disconnected: 'Non connecté au serveur MOM',
  },
  boolean: {
    true: 'Oui',
    false: 'Non',
  },
  table: {
    paginate: 'Affichage des éléments de {startsAt} à {endsAt} sur {totalRows}',
    noData: 'Aucun résultat',
  },
  modal: {
    delete: 'Suppression',
    deactivate: 'Désactivation',
  },
  tab: {
    calendar: 'Calendrier',
    list: 'Liste',
  },
  dataIterator: {
    rowsPerPageText: 'Élements par page:',
    rowsPerPageAll: 'Tous',
    pageText: '{0}-{1} de {2}',
    noResultsText: 'Aucun enregistrement correspondant trouvé',
    nextPage: 'Page suivante',
    prevPage: 'Page précédente',
  },
  dataTable: {
    rowsPerPageText: 'Lignes par page:',
  },
  noDataText: 'Aucune donnée disponible',
  confirm: {
    add: 'Voulez-vous ajouter cet élément à la liste?',
    delete: 'êtes-vous sûr de vouloir supprimer cet élément?',
  },
  created: 'Date de création',
  updated: 'Date de mise à jour',
  date: {
    aujourdhui: 'Aujourdhui',
    hier: 'Hier',
    ilYaNJours: 'Il y a {0} jours',
    title: 'Date',
  },
  joursSemaine: {
    MONDAY: 'Lundi',
    TUESDAY: 'Mardi',
    WEDNESDAY: 'Mercredi',
    THURSDAY: 'Jeudi',
    FRIDAY: 'Vendredi',
    SATURDAY: 'Samedi',
    SUNDAY: 'Dimanche',
  },
  unlock: {
    success: "L'entité a été déverrouillée",
  },
  lock: {
    success: "L'entité a été verrouillée",
  },
  already: {
    locked: "L'entité est déjà lockée",
  },
  periode: 'Période',
  leaveTitle: 'Voulez-vous continuer ? ',
  leaveConfirm:
    'Vous avez des modifications en attente, êtes-vous sûr de vouloir quitter ?',
  api: {
    error: {
      403: "Vos habilitations ne vous permettent pas d'exécuter cette action",
      404: 'Ressource non trouvée',
      500: 'Une erreur serveur est survenue',
    },
  },
  opened: {
    by: "L'objet est ouvert par : ",
  },
  account: 'Mon compte',
  status: {
    encours: 'En cours',
  },
  authConfirm: {
    message:
      "Un code vous a été envoyé sur votre téléphone sur le numéro {0}.<br> Merci de le saisir pour poursuivre votre authentification. Si votre numéro a changé ou n'est pas le bon, merci de contacter le CIEM",
    codeConfirmation: 'Le code de confirmation',
  },
  error: {
    technique: {
      essenciem:
        "Une erreur technique dans le logiciel EssenCIEM a eu lieu, veuillez contacter le support pour plus d'informations.",
      extraciem:
        "Une erreur technique dans le logiciel ExtraCIEM a eu lieu, veuillez contacter le support pour plus d'informations.",
    },
  },
}

const lang = Object.assign(
  basic,
  Login,
  Entity,
  Adherent,
  Home,
  Correspondant,
  Document,
  Fiche,
  Mutation,
  Assistance,
  Utilisateur,
  Question,
  Password,
  Registration,
  Forgot,
  Gestionnaire,
  Download,
)
export default lang
